import { action, decorate, observable } from "mobx";

import {
    getReferralHistory
} from "../services/ReferralService";

class ReferralStore {
    referralHistory = [1,2];
    isLoading = false;

    getReferralHistory = async (via) => {
        this.isLoading = true;
        const { data, error } = await getReferralHistory();
        
        if (data) {
            this.referralHistory = data;
            this.isLoading = false;
            return { data };
        } else {

            this.isLoading = false;
            return { error };
        }
    }
}

decorate(ReferralStore, {
    isLoading: observable,
    referralHistory: observable,
    getReferralHistory: action
});
export default new ReferralStore();
